import "../src/dist/styles.css";
import About from "./Pages/About";
import Home from "./Pages/Home";
import Navbar from "../src/components/Navbar";
import { Route, Routes } from "react-router-dom";
import Models from "./Pages/Models";
import TestimonialsPage from "./Pages/TestimonialsPage";
//import Team from "./Pages/Team";
import Contact from "./Pages/Contact";
import Trips from "./Pages/Trips";
import Privacy from "./Pages/PrivacyPolicy";
import TermsOfService from "./Pages/TermsOfService";


function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="models" element={<Models />} />
        <Route path="testimonials" element={<TestimonialsPage />} />
        <Route path="contact" element={<Contact />} />
        <Route path="/trips/:title/:id" element={<Trips />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="termsOfService" element={<TermsOfService />} />
      </Routes>
    </>
  );
}

export default App;
